import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-default-modal',
  templateUrl: './default-modal.component.html',
  styleUrls: ['./default-modal.component.scss']
})
export class DefaultModalComponent implements OnInit {
  @Input() title: string = 'Erro';
  @Input() text!: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }
}
